import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnarchiveIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Unarchive",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M12.18 12.13H5.55c-.84 0-1.52.68-1.52 1.52v13.17c0 .84.68 1.52 1.52 1.52h21.28c.84 0 1.51-.68 1.52-1.52V13.65c0-.84-.68-1.51-1.52-1.52h-6.58v3.04c0 .54-.43.99-.98 1.01h-6.12c-.54-.02-.98-.47-.98-1.01v-3.04Zm-8.34-.89 24.91-4.57c.82-.15 1.37-.93 1.23-1.76V4.9c-.15-.82-.93-1.37-1.76-1.23h-.01L3.24 8.25c-.83.15-1.37.94-1.22 1.77s.94 1.37 1.77 1.22h.04Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M21.57 9.86c-.29 0-.58-.11-.81-.33l-4.91-4.91-4.91 4.91c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62l5.71-5.71a1.15 1.15 0 0 1 1.62 0l5.71 5.71a1.14 1.14 0 0 1-.81 1.95Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 24.71c-.63 0-1.14-.51-1.14-1.14V3A1.14 1.14 0 1 1 17 3v20.57c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26.14 29.29H5.57c-1.89 0-3.43-1.54-3.43-3.43V19a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V19a1.14 1.14 0 1 1 2.28 0v6.86c0 1.89-1.54 3.43-3.43 3.43ZM11.29 15.57h-8c-1.89 0-3.43-1.54-3.43-3.43V9.85c0-1.89 1.54-3.43 3.43-3.43h1.14a1.14 1.14 0 1 1 0 2.28H3.29c-.63 0-1.14.51-1.14 1.14v2.29c0 .63.51 1.14 1.14 1.14h8a1.14 1.14 0 1 1 0 2.28ZM28.43 15.57h-8a1.14 1.14 0 1 1 0-2.28h8c.63 0 1.14-.51 1.14-1.14V9.86c0-.63-.51-1.14-1.14-1.14h-1.14a1.14 1.14 0 1 1 0-2.28h1.14c1.89 0 3.43 1.54 3.43 3.43v2.29c0 1.89-1.54 3.43-3.43 3.43Z"
      })]
    })
  }));
};